import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/configuraciones-dispersion-bancaria';

export const getConfiguracionesDispersionBancaria = async () => {
  try {
    const response = await API.get(`${baseURI}/`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getConfiguracionDispersionBancaria = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}/`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

export const postConfiguracionDispersionBancaria = async (data) => {
  try {
    const response = await API.post(`${baseURI}/`, data);
    return response.data;
  } catch (err) {
    onError(err);
    throw err;
  }
};

export const patchConfiguracionDispersionBancaria = async (id, data) => {
  try {
    const response = await API.patch(`${baseURI}/${id}/`, data);
    return response.data;
  } catch (err) {
    onError(err);
    throw err;
  }
};

export const deleteConfiguracionDispersionBancaria = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}/`);
    return response.data;
  } catch (err) {
    onError(err);
    throw err;
  }
};

export const autorizarConfiguracionDispersionBancaria = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}/autorizar/`);
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const cancelarConfiguracionDispersionBancaria = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}/cancelar/`);
    onSuccess(response, 'Cancelado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const reactivarConfiguracionDispersionBancaria = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}/reactivar/`);
    onSuccess(response, 'Reactivado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
